export default {
    "title": "Fichas técnicas / {{client}}",
    "filters": {
        "materialType": "Tipo de material",
        "material": "Material",
        "description": "Descripción",
        "technicalSheetNumber": "Código AC",
        "diameter": "Diámetro (cm)",
        "height": "Altura (mm)",
        "zbot": "Botes",
        "ztap": "Tapas",
        "zaux": "Tapones",
        "all": "Todos"
    },
    "technicalsSheetsHeader": "<0>{{count}}</0> fichas técnicas encontradas",
    "technicalsSheetsZBotHeader": "<0>{{count}}</0> botes encontrados",
    "technicalsSheetsZTapHeader": "<0>{{count}}</0> tapas encontradas",
    "technicalsSheetsZAuxHeader": "<0>{{count}}</0> tapones encontrados",
    "technicalsSheetsTableColumns": {
        "material": "Material",
        "description": "Descripción",
        "codeAC": "Código AC",
        "packingStandard": "Norma embalaje",
        "diameter": "Diámetro (cm)",
        "height": "Altura (mm)",
        "download": "Descargar (PDF)",
        "selection": "Seleccionar"
    },
    "bulkDownload": {
        "button": "Descargar fichas ({{count}})",
        "selectTitle": "Seleccionar todas las fichas filtradas",
        "progress": "Descargando {{current}}/{{total}}...",
        "queued": "En cola, esperando para empezar la descarga...",
        "maxLimit": "Máximo {{max}} fichas por descarga",
        "success": "Se han descargado {{downloaded}} fichas técnicas en un archivo ZIP",
        "partial": "Descarga completada: {{downloaded}} fichas incluidas y {{failed}} con error (ver errores.txt dentro del ZIP)",
        "empty": "No se ha podido descargar ninguna ficha técnica"
    },
    "nameCollection": "fichas técnicas"
}